/**
 * liveReportDetailsViewModel — pure `(reduxState, rawReport) → page props` for live-report details.
 *
 * `getLiveReport` does not land in `state.data` — the Screen keeps the raw payload in local state
 * (via `useLiveReportDetailsData`) and passes it here for mapping. Error comes from the api slice;
 * subjects from static data (with report-embedded subjects preferred in the adapter).
 * Loading is owned by `useLiveReportDetailsData`.
 */
import {
    toUILiveSessionReportDetails,
    type ApiLiveReportDetails,
} from "../../../adapters/parent/LiveReports/liveReportDetailsAdapter"
import { type UILiveSessionReportDetails } from "../../../ui/types"

export type LiveReportDetailsViewModel = {
    report: UILiveSessionReportDetails | null
    /** Blocking error when there is nothing to show. */
    error: unknown | null
    /** Raw student blob for `openCalendly` (not on the UIType). */
    studentForCalendly: ApiLiveReportDetails["student"]
}

/** Redux root is still untyped in this app — keep the VM boundary explicit. */
export function liveReportDetailsViewModel(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: any,
    raw: ApiLiveReportDetails | null
): LiveReportDetailsViewModel {
    const req = state?.api?.getLiveReport
    const subjects = state?.data?.staticData?.school_subjects ?? []
    const hasReport = raw != null

    return {
        report: toUILiveSessionReportDetails(raw, subjects),
        error: hasReport ? null : (req?.error ?? null),
        studentForCalendly: raw?.student ?? null,
    }
}
